<template>
  <div>
    Show Campaing report
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>

</style>
